// ----------------------------------------------------------------------
export var Paper = function Paper() {
  return {
    MuiPaper: {
      styleOverrides: {// rounded: { borderRadius: theme.shape.borderRadiusMd }
      }
    }
  };
};